export default __webpack_public_path__ + "static/media/full-retirement-sum-mobile.8f8fe765.svg";